import styled from 'styled-components';
import { theme } from '../../styles/theme';

// only have warning type for now
type BannerType = 'warning';

interface IProps {
  children: React.ReactNode;

  type: BannerType;
}

const ColorMapper: Record<
  BannerType,
  { backgroundColor: string; borderColor: string }
> = {
  warning: {
    backgroundColor: theme.colors.red100,
    borderColor: theme.colors.red500,
  },
};

const Container = styled.div<{ $type: BannerType }>`
  width: 100%;
  background-color: ${({ $type }) => ColorMapper[$type].backgroundColor};
  border-left: 2px solid ${({ $type }) => ColorMapper[$type].borderColor};
  padding: 16px;
`;

const InPageBanner = ({ children, type }: IProps) => {
  return <Container $type={type}>{children}</Container>;
};

export default InPageBanner;
